// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assets de las fichas que se utilizan para elegir el monto de la apuesta
 * @param {*} scene 
 */
export function cargaAssetsFichasEleccion(scene) {
    // Ficha 10
    scene.load.image(
      "ficha10",
      ROUTES.rutaRuletaFichasEleccion + "/ficha1EstaticaResized.png"
    );
    scene.load.image(
      "ficha10Hover",
      ROUTES.rutaRuletaFichasEleccion + "/ficha1EstaticaHoverResized.png"
    );
    scene.load.image(
      "ficha10Selected",
      ROUTES.rutaRuletaFichasEleccion + "/ficha1EstaticaSelectedResized.png"
    );

    // Ficha 20
    scene.load.image(
      "ficha20",
      ROUTES.rutaRuletaFichasEleccion + "/ficha2EstaticaResized.png"
    );
    scene.load.image(
      "ficha20Hover",
      ROUTES.rutaRuletaFichasEleccion + "/ficha2EstaticaHoverResized.png"
    );
    scene.load.image(
      "ficha20Selected",
      ROUTES.rutaRuletaFichasEleccion + "/ficha2EstaticaSelectedResized.png"
    );

    // Ficha 50
    scene.load.image(
      "ficha50",
      ROUTES.rutaRuletaFichasEleccion + "/ficha3EstaticaResized.png"
    );
    scene.load.image(
      "ficha50Hover",
      ROUTES.rutaRuletaFichasEleccion + "/ficha3EstaticaHoverResized.png"
    );
    scene.load.image(
      "ficha50Selected",
      ROUTES.rutaRuletaFichasEleccion + "/ficha3EstaticaSelectedResized.png"
    );

    // Ficha 100
    scene.load.image(
      "ficha100",
      ROUTES.rutaRuletaFichasEleccion + "/ficha4EstaticaResized.png"
    );
    scene.load.image(
      "ficha100Hover",
      ROUTES.rutaRuletaFichasEleccion + "/ficha4EstaticaHoverResized.png"
    );
    scene.load.image(
      "ficha100Selected",
      ROUTES.rutaRuletaFichasEleccion + "/ficha4EstaticaSelectedResized.png"
    );
}